import React, { useState } from "react";
import BizinBackend from "../../../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import NotificationModal from "../../../../components/Common/NotificationModal";

export default function GridBody({ rowData, onClose, onCancelSuccess }) {
  const { access_token } = useSelector((state) => ({
    access_token: state.login.user.access_token,
  }));
  const csrfToken = useGetCsrfToken();
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await BizinBackend.executeProcedure(
        { ID_Local_Entrega: rowData?.ID },
        "SRM_Agendamento_Cancela_Local_Entrega",
        csrfToken,
        access_token,
      );
      setShowSuccess(true);
    } catch (error) {
      console.error("Erro ao processar o cancelamento:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAll = () => {
    setShowSuccess(false);
    if (onCancelSuccess) onCancelSuccess();
    onClose();
  };

  return (
    <>
      <NotificationModal
        isOpen={!showSuccess}
        type="warning"
        titleCustom="Deseja cancelar este Local de Entrega?"
        message='Ao clicar em "Confirmar", o Local de Entrega selecionado será removido.'
        confirmButton
        onClose={onClose}
        onConfirm={handleConfirmDelete}
      />

      <NotificationModal
        isOpen={showSuccess}
        type="success"
        message="O Local de Entrega foi removido com sucesso!"
        onClose={handleCloseAll}
      />
    </>
  );
}
